export default {"src":"/_next/static/media/DOCUMENT_ACTIVE_ICON.026ee253.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};